import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { MasterPageSidebar } from "./sidebar";

export function MasterPage({ children }: { children: ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="w-full min-h-full flex">
      <MasterPageSidebar />

      <div className="w-full flex flex-col justify-between bg-[#EAEEF3]">
        <div>
          <Header />

          <main className="w-full box-border py-4 md:py-5 lg:py-6">
            {children}
          </main>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default MasterPage;
